import { BrowserRouter as Router } from "react-router-dom"
import HomeScreen from "./screens/HomeScreen"

function App() {
  return (
    <Router>
      <HomeScreen />
    </Router>
  )
}

export default App
